import {Vue} from 'ui.vue';

const langMessages = Vue.getFilteredPhrases("VT_DIALOG_");

// constants
export const DIALOG_TYPES = {
	ALERT: 'alert', // ex: Congrats! record created
	CONFIRM: 'confirm', // ex: Please confirm delete
	PROMPT: 'prompt' // ex: Type your password to save changes
}

export const CONFIRM_TYPES = {
	BASIC: 'basic', // ex: click to confirm
	SOFT: 'soft', // ex: click 3 times to confirm
	HARD: 'hard' // ex: enter verification, then click to confirm
}

export const ANIMATION_TYPES = {
	FADE: 'dg-fade',
	ZOOM: 'dg-zoom',
	BOUNCE: 'dg-bounce'
}

export const CLASS_TYPES = {
	MAIN_CONTENT: 'mainContent',
	BODY: 'body',
	TITLE: 'title',
	FOOTER: 'footer',
	OK_BTN: 'okBtn',
	CANCEL_BTN: 'cancelBtn'
}

export const DEFAULT_OPTIONS = {
	hasCloseBtn          : false,
	html                 : false,
	loader               : false,
	reverse              : false,
	backdropClose        : false,
	okText               : langMessages.hasOwnProperty('VT_DIALOG_CONFIRM') ? langMessages['VT_DIALOG_CONFIRM'] : 'Continue',
	cancelText           : langMessages.hasOwnProperty('VT_DIALOG_CANCEL') ? langMessages['VT_DIALOG_CANCEL'] : 'Cancel',
	view                 : null,
	type                 : CONFIRM_TYPES.BASIC,
	window               : DIALOG_TYPES.CONFIRM,
	message              : langMessages.hasOwnProperty('VT_DIALOG_PROCEED_REQUEST') ? langMessages['VT_DIALOG_PROCEED_REQUEST'] : 'Proceed with the request?',
	clicksCount          : 3,
	animation            : 'zoom',
	customClass          : '',
	verification         : 'continue',
	verificationHelp     : 'Type "[+:verification]" below to confirm',
	promptHelp      	 : 'Type in the box below and click "[+:okText]"'
}
